import { render, staticRenderFns } from "./CardRecommand.vue?vue&type=template&id=d29dd91c&"
import script from "./CardRecommand.vue?vue&type=script&lang=js&"
export * from "./CardRecommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports